import React from 'react';
import {DoppeActionTypeSpeedDial} from '../doppe-action-type-speed-dial';
import {classes, style} from './doppe-action-type-speed-dial-widget-new.st.css';
import {Button, ButtonType, Icon} from '@wix/devzai-utils-react';
import {AsyncValueResource} from '@wix/devzai-utils-common';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {useDoppViewerIsRtl} from '../../../components/doppe-viewer-lang-dictionary/doppe-viewer-lang-dictionary';
import {
    DoppeActionTypeSpeedDialWidgetIconArrowLeft,
    DoppeActionTypeSpeedDialWidgetIconArrowRight,
    DoppeActionTypeSpeedDialWidgetIconOpenSearch
} from './doppe-action-type-speed-dial-widget-icons';
import {
    BymoPageViewerMode,
    useBymoPageViewerContext
} from '../../../components/bymo-page-viewer-context/bymo-page-viewer-context';
import {useDoppeViewerClientServices} from '../../../client/doppe-user-app/doppe-viewer-client-services';
import {doppeHideableValueIsVisibleAndNotEqualValue} from '../../../client-server-common/types/doppe-hideable-value';
import {
    DoppePageAsyncValueRenderer
} from '../../../components/doppe-page-async-value-renderer/doppe-page-async-value-renderer';
import {
    DoppeViewerModalPanel,
    DoppeViewerModalPanelLayout
} from '../../../components/doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {useDoppeViewerLocales} from "../../../client/doppe-viewer-locales/doppe-viewer-locales";


const AsyncDoppeActionTypeSpeedDialWidgetAutoCompletePanel = new AsyncValueResource({
    fetchFunction: async () => {
        return (await import('./doppe-action-type-speed-dial-auto-complete-panel-new')).default
    }
})

export const DoppeActionTypeSpeedDialWidget = React.memo(function DoppeActionTypeSpeedDialWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeSpeedDial.ActionSettings>
) {
    const {
        actionContext,
        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    const action = actionContext.action;

    const {
        searchPlaceholder,
    } = action.settings;

    const doppeViewerLocales = useDoppeViewerLocales();
    const clientServices = useDoppeViewerClientServices();
    const pageViewerContext = useBymoPageViewerContext();
    const isRtl = useDoppViewerIsRtl();

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                fullScreenSearchMode: true
            }, className, CommonClasses.button)}
            style={{
                ...styleProp
            }}
        >
            <div
                className={style(classes.textBoxContainer, {}, FlexLayout.row.alignToCenter)}
                onClick={() => {
                    if (pageViewerContext.mode === BymoPageViewerMode.Live) {
                        clientServices.viewerAnalyticsClient.logEvent('uouSearchBoxClicked', {
                            hypeUserId: pageViewerContext.doppeUserId,
                            pageId: pageViewerContext.bymoPageId,
                            source: 'ArrowButton',
                            linkId: '',
                        })
                    }

                    actionContext.modalsController.showInnerModal({
                        content:  ({modalController}) => (
                            <DoppeViewerModalPanel
                                className={style(classes.modal, FlexLayout.column.default)}
                                mobileLayout={DoppeViewerModalPanelLayout.FullScreen}
                                desktopLayout={DoppeViewerModalPanelLayout.FullScreen}

                            >
                                <DoppePageAsyncValueRenderer
                                    asyncValue={AsyncDoppeActionTypeSpeedDialWidgetAutoCompletePanel}
                                    className={style(classes.autoCompleteDropPanelLoader)}
                                >
                                    {DoppeActionTypeSpeedDialWidgetAutoCompletePanel => (
                                        <DoppeActionTypeSpeedDialWidgetAutoCompletePanel
                                            className={style(classes.autoCompleteDropPanel, {})}
                                            // onMouseDown={e => e.preventDefault()}
                                            actionContext={actionContext}
                                            onClose={() => {
                                                modalController.closeWindowImmediately();
                                            }}
                                        />
                                    )}
                                </DoppePageAsyncValueRenderer>
                            </DoppeViewerModalPanel>
                        )
                    })
                }}
            >
                <Icon
                    className={style(classes.searchIcon, {})}
                    icon={DoppeActionTypeSpeedDialWidgetIconOpenSearch}
                />
                <div
                    className={style(classes.codeInput, FlexLayout.fillRemainingHorizontalSpace)}
                    onClick={() => {

                    }}
                >
                    {doppeHideableValueIsVisibleAndNotEqualValue(searchPlaceholder, '') ? searchPlaceholder : doppeViewerLocales.enterACode}
                </div>
                <Button
                    className={style(classes.autoCompleteSubmitIconButton)}
                    buttonType={ButtonType.SubmitButton}
                    onClick={() => {
                        if (pageViewerContext.mode === BymoPageViewerMode.Live) {
                            clientServices.viewerAnalyticsClient.logEvent('uouSearchBoxClicked', {
                                hypeUserId: pageViewerContext.doppeUserId,
                                pageId: pageViewerContext.bymoPageId,
                                source: 'ArrowButton',
                                linkId: '',
                            })
                        }
                    }
                    }
                >
                    <Icon
                        icon={isRtl ? DoppeActionTypeSpeedDialWidgetIconArrowLeft : DoppeActionTypeSpeedDialWidgetIconArrowRight}
                    />
                </Button>
            </div>
        </div>
    );
});